import { animated, useSpring } from '@react-spring/web';
import classNames from 'classnames';
import type { ComponentProps } from 'react';
import { useState } from 'react';
import styled from 'styled-components';

import { LoadingButton } from '#src/atoms/buttons/LoadingButton/index.tsx';

const Root = styled.div`
  overflow: hidden;
  position: relative;
  &.fullWidth {
    width: 100%;
  }
`;
const Button = styled(LoadingButton)`
  &.delayDisabled {
    opacity: 0.75;
    pointer-events: none;
  }
  transition: 300ms opacity ease-in-out;
`;
const DelayOverlay = styled(animated.div)`
  position: absolute;
  inset: 0;
  z-index: 1;
  background: var(--c-nl-500);

  *.delayDisabled > & {
    background-color: var(--c-nl-500);
  }
`;

type Props = { delay: number } & ComponentProps<typeof LoadingButton>;
export const DelayLoadingButton = ({ delay, ...rest }: Props) => {
  const [disabled, setDisabled] = useState(delay > 0);

  const style = useSpring({
    from: {
      x: '0%',
    },
    to: {
      x: '100%',
    },
    onRest: () => setDisabled(false),
    config: { duration: delay },
  });

  return (
    <Root className={classNames({ fullWidth: rest.fullWidth })}>
      <DelayOverlay style={style} />
      <Button {...rest} className={classNames({ delayDisabled: disabled })}>
        {rest.children}
      </Button>
    </Root>
  );
};
